import Commons from '../../../Services/Common/Common';

export const M_EMT_BASIC_Schema = {
  mapper: {
    /** 비상연락망 목록 조회 GetEmTelR1 (본인 부서 / 외부인은 사업장 hm·bo) */
    search1: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      DepCd: (context) =>
        Commons.EncryptAES(context.userInfo?.depCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
